var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.286 0H7.714C6.127 0 5.01 1.606 5.01 3.444L5 23l.006.114a1 1 0 0 0 1.515.74L12 20.504l5.48 3.348A1 1 0 0 0 19 23V3.444C19 1.608 17.872 0 16.286 0Zm0 1c.902 0 1.647 1.006 1.71 2.27l.004.174V23l-6-3.667L6 23l.009-19.556c0-1.286.698-2.348 1.583-2.438L7.714 1h8.572Z",
    fillRule: "nonzero"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bookmark.37e031b767f7e6b7e6c976468f8b31ce.svg";